export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 80,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_title_custDepName') || '部门名称',
    field: 'custDepName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 220,
  },
  {
    title: that.$l('table_title_custOrgName') || '分支机构',
    field: 'custOrgName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 220,
  },
  {
    title: that.$l('table_title_modifyInfo') || '数据更新',
    field: 'modifyInfo',
    minWidth: 170,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
